// extracted by mini-css-extract-plugin
export var gatewaySwitcher = "HeaderGateway-module--gatewaySwitcher--a4537";
export var gatewaySwitcherButton = "HeaderGateway-module--gatewaySwitcherButton--70cfb";